import React, { useEffect } from 'react';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { validatePermissions } from '@sde/widgets-core/src/redux/resources/user/helpers';
import { useModal } from 'src/state/modal';
import { event } from '@uhg-abyss/web/tools/event';
import uniqBy from 'lodash/uniqBy';
import { styled } from '@uhg-abyss/web/tools/styled';
import { sections } from './sections';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';

const StyledAccordionItemHeader = styled(Accordion.Header, {
  color: '$black',
});

export const NewSearchFlyout = () => {
  const { modals, modalData } = useModal.state();
  const { toggleModal } = useModal.actions();
  const { user } = useUser.state();

  const newSearch = 'new-search';

  const isModalOpen = !!modals[newSearch];
  useEffect(() => {
    if (isModalOpen) {
      event('MODAL_OPEN', { modalName: 'new search flyout' });
    }
  }, [isModalOpen]);

  const handleClose = () => {
    toggleModal({ key: newSearch, isOpen: false });
    event('MODAL_CLOSE', { modalName: 'new search flyout' });
  };

  const appPermissions = {
    'claim-search': validatePermissions(user, 'claims.read'),
    'eligibility-search': validatePermissions(user, 'eligibility.read'),
    'referrals-search':
      validatePermissions(user, 'referrals.read') &&
      getFeature('REMOVE_REFERRALS_REDIRECT'),
  };

  const displayedSections = sections.filter((section) => {
    return appPermissions[section.id];
  });

  let defaultOpen = 'claim-search';
  let checkboxIsDisabled = false;
  let isDisabled = false;
  if (modalData[newSearch]) {
    const { memberInfo, defaultAccordion, disabledAccordion } =
      modalData[newSearch];
    checkboxIsDisabled = !(
      uniqBy(memberInfo, (member) => JSON.stringify(member)).length === 1
    );

    if (defaultAccordion) {
      defaultOpen = defaultAccordion;
    }

    if (disabledAccordion) {
      isDisabled = disabledAccordion;
    }
  }

  return (
    <React.Fragment>
      <Drawer
        isOpen={isModalOpen}
        onClose={handleClose}
        position="right"
        data-testid="new-search-flyout"
        title="New Search"
        size="500px"
        closeOnClickOutside={false}
      >
        <Accordion defaultValue={defaultOpen}>
          <For each="accordionItem" of={displayedSections}>
            <Accordion.Item
              key={accordionItem.id}
              value={accordionItem.id}
              isDisabled={isDisabled === accordionItem.id}
            >
              <Accordion.Trigger>
                <Layout.Group>
                  <IconBrand
                    size="24px"
                    icon={accordionItem.icon}
                    variant="twotone"
                  />
                  <StyledAccordionItemHeader>
                    {accordionItem.name}
                  </StyledAccordionItemHeader>
                </Layout.Group>
              </Accordion.Trigger>
              <Accordion.Content>
                {React.createElement(accordionItem.component, {
                  checkboxIsDisabled,
                })}
              </Accordion.Content>
            </Accordion.Item>
          </For>
        </Accordion>
      </Drawer>
    </React.Fragment>
  );
};
